import React, {Component} from 'react'
import {Popup, Button, Checkbox, Modal, Message} from 'semantic-ui-react'
import Utils from '../../modules/utils'
import {isCustomer} from '../cads/is-role'
import {canSeeCost, canSeeWholesale, canSeeMargin} from '../custom-access/can'
import {hideableInfo, hideableInfoCustomer, defaultFields} from './settings-modal'

class ExportToExcel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      loading: false,
      exportByBrand: false,
      exportByMonth: false,
      exportNoImages: false,
      hideUnitsUnder: false,
      units: null,
      exportByCategory: false,
      showVisibleFields: false,
      excludedFields: []
    }
  }

  clickButton = () => {
    let {
      showFields, shippedData, salesOrderData, cads, contact, fromDate, toDate,
      atsRep, cadIds, fieldOnChange, sortBy, searchString, vendorOrders
    } = this.props
    let {exportByBrand, exportByMonth, exportNoImages, exportByCategory, hideUnitsUnder} = this.state
    let ids = Object.keys(cadIds)

    const styleNumbers = ids.map(x => cads.find(y => y.i == x).s)

    const filteredShippedData = Object.entries(shippedData).filter(([key]) =>
      styleNumbers.includes(key)
    )

    const filteredSalesOrderDataByStyleNumber = Object.entries(salesOrderData).filter(([key]) =>
      styleNumbers.includes(key)
    )

    const filteredSalesOrderDataById = Object.entries(salesOrderData).filter(([key]) =>
      ids.includes(key)
    )

    const filteredAtsRep = Object.entries(atsRep).filter(([key]) =>
      ids.includes(key)
    )

    //the excel has no vpo rows of its own, so send the same pending containers the card shows
    const pendingContainerNumbers = {}
    ids.forEach(id => {
      const numbers = [...new Set(
        (vendorOrders || [])
          .filter(order => order.cad_id == id)
          .flatMap(order => (order.pending_container_number || '').split(','))
          .map(x => x.trim())
          .filter(x => x != '')
      )]

      if (numbers.length > 0) pendingContainerNumbers[id] = numbers.join(', ')
    })

    const exportShowFields = [
      ...showFields.filter(f => !defaultFields.includes(f) && f !== 'Future Stock'),
      ...defaultFields.filter(f => !this.state.excludedFields.includes(f))
    ]

    const data = {
      cad_ids: ids,
      show_fields: exportShowFields,
      shipped_data: JSON.stringify(Object.fromEntries(filteredShippedData)),
      sales_order_data_by_style_number: JSON.stringify(Object.fromEntries(filteredSalesOrderDataByStyleNumber)),
      sales_order_data_by_id: JSON.stringify(Object.fromEntries(filteredSalesOrderDataById)),
      ats_rep: JSON.stringify(Object.fromEntries(filteredAtsRep)),
      pending_container_numbers: JSON.stringify(pendingContainerNumbers),
      contact,
      from_date: fromDate,
      to_date: toDate,
      export_by_brand: exportByBrand,
      export_by_month: exportByMonth,
      export_no_images: exportNoImages,
      export_by_category: exportByCategory,
      hide_units_under: hideUnitsUnder,
      sort_by: sortBy,
      search_string: searchString
    }
    this.setState({loading: true})
    clearTimeout(this.timeout)
    Utils.post('export_to_excel', data, (err, res) =>
    {
      if (err) {
        alert('There was an error when trying to export to excel.')
      } else {
        if (res.data.url != null) {
          window.location = res.data.url
        } else {
          fieldOnChange(null, {value: res.data.id, name: 'reportId'}, false)
        }
      }
      this.setState({open: false, loading: false})
    })
  }

  open = () => {
    let {cadIds} = this.props
    let ids = Object.keys(cadIds)
    if (ids.length == 0) {
      alert('Please select at least one cad!')
    } else {
      this.setState({open: true})
    }
  }

  toggleOnChange = (event, {value, name, checked}) => {
    let newState = {}
    newState[name] = checked
    if (name == 'exportByMonth' && checked) {newState['exportByBrand'] = false; newState['exportByCategory'] = false}
    if (name == 'exportByBrand' && checked) {newState['exportByMonth'] = false; newState['exportByCategory'] = false}
    if (name == 'exportByCategory' && checked) {newState['exportByBrand'] = false; newState['exportByMonth'] = false}
    this.setState(newState)
  }

  unitsOnChange = (event, {name, value}) => {
    alert(value)
  }

  render() {
    let {open, exportByBrand, exportByMonth, exportNoImages, exportByCategory, hideUnitsUnder, units, loading, showVisibleFields, excludedFields} = this.state
    let {showFields} = this.props
    let fields = this.excelFields()

    const has = f => showFields.includes(f)
    const excelExportError = !isCustomer() && has('Future ATS') &&
                             (has('Shipped') || has('PO') || has('Pending PO') || has('Hold') || has('Worksheet') || has('On Hand'))

    return (
      <React.Fragment>
        <Popup content='Export to Excel' position='right center'
          trigger={
            <Button onClick={this.open} basic circular icon='file excel outline' />
          }
        />
  
        <Modal size='large' open={open} onClose={this.close} closeIcon>
          <Modal.Header>Export CADs to Excel</Modal.Header>
  
          <Modal.Content>
            {excelExportError ?
              <Message warning>
                <Message.Header>You must change visible fields!</Message.Header>
                <p>You CANNOT export <b>Future units</b> with <b>orders / On Hand</b></p>
              </Message>
            : null}
            <Checkbox toggle label='Export By Brand' onChange={this.toggleOnChange} name='exportByBrand' checked={exportByBrand} style={{marginBottom: '10px', display: 'block'}} />
            <Checkbox toggle label='Export By Sub-Category' onChange={this.toggleOnChange} name='exportByCategory' checked={exportByCategory} style={{marginBottom: '10px', display: 'block'}} />
            <Checkbox toggle label='Export By Month' onChange={this.toggleOnChange} name='exportByMonth' checked={exportByMonth} style={{marginBottom: '10px', display: 'block'}} />
            <Checkbox toggle label='Export No Images' onChange={this.toggleOnChange} name='exportNoImages' checked={exportNoImages} style={{marginBottom: '10px', display: 'block'}} />
            <Checkbox toggle label='Hide Units Under' onChange={this.toggleOnChange} name='hideUnitsUnder' checked={hideUnitsUnder} style={{marginBottom: '10px', display: 'none'}} />
  
            <input placeholder="Enter min units" type="number" min="5" max="999999" step="1" onChange={this.unitsOnChange} value={units} style={{display: 'none'}}/>
  
            <br/>
  
            <div style={{cursor: 'pointer'}} onClick={this.toggleVisibleFields}>
              {showVisibleFields ? '▼' : '▶'} Select visible fields
            </div>
  
            {
              showVisibleFields
              ?
              <div style={{marginTop: '15px'}}>
                <div style={{columnCount: '3', zoom: '125%', lineHeight: '200%'}}>
                  {fields.map((fieldName, index) => {
                    const isDefault = defaultFields.includes(fieldName)
                    return (
                      <div key={index}>
                        <Checkbox
                          label={fieldName}
                          onChange={isDefault ? () => this.toggleDefaultField(fieldName) : () => this.excelFieldOnChange(fieldName)}
                          checked={isDefault ? !excludedFields.includes(fieldName) : showFields.includes(fieldName)}
                        />
                      </div>
                    )
                  })}
                  <Button basic style={{padding: '5px 8px', marginTop: '10px'}} onClick={this.showAll}>show all</Button>
                </div>
              </div>
              :
              null
            }
          </Modal.Content>
  
          <Modal.Actions>
            <Button onClick={this.close} basic>
              Cancel
            </Button>
            <Button primary loading={loading} disabled={excelExportError} onClick={this.clickButton}>
              Download Excel
            </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    )
  }

  close = () => {
    this.setState({open: false})
  }
  
  toggleVisibleFields = () => {
    this.setState({showVisibleFields: !this.state.showVisibleFields})
  }
  
  toggleDefaultField = (fieldName) => {
    let {excludedFields} = this.state
    if (excludedFields.includes(fieldName)) {
      excludedFields = excludedFields.filter(f => f != fieldName)
    } else {
      excludedFields = [...excludedFields, fieldName]
    }
    this.setState({excludedFields})
  }

  excelFieldOnChange = (fieldName) => {
    this.props.showFieldOnChange(fieldName)
  }
  
  //cost, wholesale and margin follow the same custom access as the cards, the server drops them too
  excelFields = () => (isCustomer() ? hideableInfoCustomer : hideableInfo)
    .filter(f => f !== 'Future Stock')
    .filter(f => f !== 'Cost' || canSeeCost())
    .filter(f => f !== 'Wholesale' || canSeeWholesale())
    .filter(f => f !== 'Margin' || canSeeMargin())

  showAll = () => {
    let {showFields, showFieldOnChange, hideAllFields} = this.props
    let fields = this.excelFields()

    if (fields.every(field => showFields.includes(field) || defaultFields.includes(field))) {
      hideAllFields()
    } else {
      fields.forEach((field) => {
        if (defaultFields.includes(field) || showFields.includes(field)) return
        showFieldOnChange(field)
      })
    }
  }

}

export default ExportToExcel
